import {
  IntervalUnit,
  ProductInfo,
  SalePricing,
} from '@wix/ambassador-premium-store/types';
import {
  aDynamoFeature,
  aDynamoProduct,
  aPurchasableCycle,
  mockedCyclePricing,
} from './general-mocks';

const DAYFUL_GUIDS = {
  DAYFUL_STANDARD: '5235e4ee-1b3f-4373-b012-4e8885ffe5d8',
  DAYFUL_ADVANCED: 'bca7c028-2002-4bfc-8993-15b480ed79fa',
};

export const SUNRISE_V2_GUIDS = {
  SUNRISE_V2_LIGHT: '519cd0e3-6a86-4d20-ae25-636f37fad2b8',
  SUNRISE_V2_CORE: '85d9db15-0d98-4d58-a592-7a591ddc601b',
  SUNRISE_V2_BUSINESS: 'b94fb9bc-794c-4900-90e2-9e8489a33115',
  SUNRISE_V2_BUSINESS_ELITE: '9401c5fd-b9ee-4f8d-9809-b002bbcc2b1d',
  SUNRISE_V2_ENTERPRISE: '9832e35a-f7f8-4ced-89f2-c2b3d80516a6',
};

export const WIX_STUDIO_V1_GUIDS = {
  WIX_STUDIO_V1_BASIC: 'f66e2df5-ff31-4548-8f56-5bea4c85d18c',
  WIX_STUDIO_V1_STANDARD: '6199a01f-ffe5-4696-b840-3c1791fa4c55',
  WIX_STUDIO_V1_PLUS: 'afb6078b-d041-4461-93b6-b431888acaae',
  WIX_STUDIO_V1_ELITE: '8f17e91f-600c-48ab-b4a5-afee7a472a87',
  WIX_STUDIO_V1_ENTERPRISE: '87914348-6f5d-4590-8cec-1e49980ed6eb',
};

export const PRODUCT_GUIDS = {
  ...DAYFUL_GUIDS,
  ...SUNRISE_V2_GUIDS,
  ...WIX_STUDIO_V1_GUIDS,
};

export const getSalePricingMockByProductId = (
  productId: string,
): SalePricing => {
  switch (productId) {
    case PRODUCT_GUIDS.DAYFUL_STANDARD:
    case PRODUCT_GUIDS.DAYFUL_ADVANCED: {
      return {
        discountPrices: [
          mockedCyclePricing({
            intervalCount: 1,
            price: 10200,
            priceWithTax: 12240,
            monthsPerCycle: 12,
            intervalUnit: IntervalUnit.YEAR,
          }),
        ],
      };
    }
    case 'b9e4d636-3b00-4991-9c05-ab4ae567ba6b': {
      return {
        discountPrices: [
          mockedCyclePricing({
            intervalCount: 3,
            price: 21600,
            priceWithTax: 25920,
            monthsPerCycle: 36,
          }),
          mockedCyclePricing({
            intervalCount: 2,
            price: 16200,
            priceWithTax: 19440,
            monthsPerCycle: 24,
          }),
          mockedCyclePricing({
            intervalCount: 1,
            price: 10200,
            priceWithTax: 12240,
            monthsPerCycle: 12,
          }),
        ],
      };
    }
    case '2018eabf-aa6c-4f9a-8403-3e08a199bfe3': {
      return {
        discountPrices: [
          mockedCyclePricing({
            intervalCount: 3,
            price: 28800,
            priceWithTax: 34560,
            monthsPerCycle: 36,
          }),
          mockedCyclePricing({
            intervalCount: 2,
            price: 13200,
            priceWithTax: 15840,
            monthsPerCycle: 24,
          }),
          mockedCyclePricing({
            intervalCount: 1,
            price: 21600,
            priceWithTax: 25920,
            monthsPerCycle: 12,
          }),
        ],
      };
    }
    case 'a9d8e28c-96a1-40e4-90a2-8a63118c912c': {
      return {
        discountPrices: [
          mockedCyclePricing({
            intervalCount: 3,
            price: 39600,
            priceWithTax: 47520,
            monthsPerCycle: 36,
          }),
          mockedCyclePricing({
            intervalCount: 2,
            price: 28200,
            priceWithTax: 33840,
            monthsPerCycle: 24,
          }),
          mockedCyclePricing({
            intervalCount: 1,
            price: 16200,
            priceWithTax: 19440,
            monthsPerCycle: 12,
          }),
        ],
      };
    }
    case '686be040-ae5a-421f-ac89-9a87ec6c73cb': {
      return {
        discountPrices: [
          mockedCyclePricing({
            intervalCount: 3,
            price: 55800,
            priceWithTax: 66960,
            monthsPerCycle: 36,
          }),
          mockedCyclePricing({
            intervalCount: 2,
            price: 42000,
            priceWithTax: 50400,
            monthsPerCycle: 24,
          }),
          mockedCyclePricing({
            intervalCount: 1,
            price: 23400,
            priceWithTax: 28080,
            monthsPerCycle: 12,
          }),
        ],
      };
    }
    case 'c3ebd545-0e50-479b-8a9d-e672a0049248': {
      return {
        discountPrices: [
          mockedCyclePricing({
            intervalCount: 3,
            price: 70200,
            priceWithTax: 84240,
            monthsPerCycle: 36,
          }),
          mockedCyclePricing({
            intervalCount: 2,
            price: 50400,
            priceWithTax: 60480,
            monthsPerCycle: 24,
          }),
          mockedCyclePricing({
            intervalCount: 1,
            price: 29400,
            priceWithTax: 35280,
            monthsPerCycle: 12,
          }),
        ],
      };
    }
    default: {
      return {
        discountPrices: [
          mockedCyclePricing({
            intervalCount: 3,
            price: 70200,
            priceWithTax: 84240,
            monthsPerCycle: 36,
          }),
          mockedCyclePricing({
            intervalCount: 2,
            price: 50400,
            priceWithTax: 60480,
            monthsPerCycle: 24,
          }),
          mockedCyclePricing({
            intervalCount: 1,
            price: 29400,
            priceWithTax: 35280,
            monthsPerCycle: 12,
          }),
        ],
      };
    }
  }
};

const dynamoProduct1 = aDynamoProduct({
  name: 'Combo',
  productId: '0643f96c-67ca-4d88-9031-fa5a5c3f46e3',
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 3,
      price: 32400,
      priceWithTax: 38880,
      monthsPerCycle: 36,
    }),
    mockedCyclePricing({
      intervalCount: 2,
      price: 25200,
      priceWithTax: 30240,
      monthsPerCycle: 24,
    }),
    mockedCyclePricing({
      intervalCount: 1,
      price: 15600,
      priceWithTax: 18720,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 1700,
      priceWithTax: 2040,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: '6e8fbb87-aca3-42bc-b8c7-c040fed78fee',
  productTypeId: '8b1b47e6-9f58-4e59-b147-cac894bec8da',
  productFamilyId: '217fdefb-918b-46cb-8cfa-c010cbff46f9',
  salePricing: {
    discountPrices: [
      mockedCyclePricing({
        intervalUnit: IntervalUnit.YEAR,
        intervalCount: 1,
        price: 19200,
        priceWithTax: 24080,
        monthsPerCycle: 12,
        percentage: 50,
      }),
    ],
  },
});

const dynamoProduct2 = aDynamoProduct({
  name: 'Unlimited',
  productId: 'a1ae2ee6-1c98-4a8a-97cc-285938c8f1b2',
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 3,
      price: 43200,
      priceWithTax: 51840,
      monthsPerCycle: 36,
    }),
    mockedCyclePricing({
      intervalCount: 2,
      price: 32400,
      priceWithTax: 38880,
      monthsPerCycle: 24,
    }),
    mockedCyclePricing({
      intervalCount: 1,
      price: 20400,
      priceWithTax: 24480,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 2200,
      priceWithTax: 2640,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: '81533fb1-25f2-4f6a-91e5-1bf06ca643d7',
  productTypeId: '8b1b47e6-9f58-4e59-b147-cac894bec8da',
  productFamilyId: '07e91af2-2c8e-485d-8a36-98ac2e8d6bab',
  salePricing: {
    discountPrices: [
      mockedCyclePricing({
        intervalCount: 1,
        price: 19200,
        priceWithTax: 24080,
        monthsPerCycle: 12,
      }),
    ],
  },
});

const dynamoProduct3 = aDynamoProduct({
  name: 'Pro',
  productId: 'c4a86593-6928-42df-b373-a5d13bcf8e8e',
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 3,
      price: 57600,
      priceWithTax: 69120,
      monthsPerCycle: 36,
    }),
    mockedCyclePricing({
      intervalCount: 2,
      price: 43200,
      priceWithTax: 51840,
      monthsPerCycle: 24,
    }),
    mockedCyclePricing({
      intervalCount: 1,
      price: 26400,
      priceWithTax: 31680,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 2700,
      priceWithTax: 3240,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: '1e89b103-da11-45de-bc5e-031dff3d21fe',
  productTypeId: '8b1b47e6-9f58-4e59-b147-cac894bec8da',
  productFamilyId: 'a74c11f7-f64a-48c8-9a23-916d90d39aa6',
});

const dynamoProduct4 = aDynamoProduct({
  name: 'Business Basic',
  productId: '3035270e-1845-4d2e-be1c-3c4af9fcbd04',
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 3,
      price: 64800,
      priceWithTax: 77760,
      monthsPerCycle: 36,
    }),
    mockedCyclePricing({
      intervalCount: 2,
      price: 48000,
      priceWithTax: 57600,
      monthsPerCycle: 24,
    }),
    mockedCyclePricing({
      intervalCount: 1,
      price: 27600,
      priceWithTax: 33120,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 2800,
      priceWithTax: 3360,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: 'da050212-3b05-4f2c-9acc-866fb94f47c8',
  productTypeId: '8b1b47e6-9f58-4e59-b147-cac894bec8da',
  productFamilyId: '15203c71-77eb-40d2-bdf3-ad74880a4fbf',
});

const dynamoProduct5 = aDynamoProduct({
  name: 'Business Unlimited',
  productId: 'db8fd4ef-4a54-4cfd-bcf0-b72502b01f8f',
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 3,
      price: 79200,
      priceWithTax: 95040,
      monthsPerCycle: 36,
    }),
    mockedCyclePricing({
      intervalCount: 2,
      price: 56400,
      priceWithTax: 67680,
      monthsPerCycle: 24,
    }),
    mockedCyclePricing({
      intervalCount: 1,
      price: 32400,
      priceWithTax: 38880,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 3300,
      priceWithTax: 3960,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: '1749634a-378e-4dd6-90d1-1709f38925f9',
  productTypeId: '8b1b47e6-9f58-4e59-b147-cac894bec8da',
  productFamilyId: '5541f621-abdb-4b9c-ab54-95f6a10d3af1',
});

const dynamoProduct6 = aDynamoProduct({
  name: 'Business VIP',
  productId: 'a3466bc7-550d-4587-9217-a1a5159a3748',
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 3,
      price: 111600,
      priceWithTax: 133920,
      monthsPerCycle: 36,
    }),
    mockedCyclePricing({
      intervalCount: 2,
      price: 84000,
      priceWithTax: 100800,
      monthsPerCycle: 24,
    }),
    mockedCyclePricing({
      intervalCount: 1,
      price: 46800,
      priceWithTax: 56160,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 4700,
      priceWithTax: 5640,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: '33740d93-ae1e-4eab-a376-652bd9624527',
  productTypeId: '8b1b47e6-9f58-4e59-b147-cac894bec8da',
  productFamilyId: '321a4b63-9d2d-46f6-a205-0f4a6f6bbc05',
});

const dynamoProduct7 = aDynamoProduct({
  name: 'VIP',
  productId: '314ddd14-c592-4ae2-822e-d34105a11dae',
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 3,
      price: 140400,
      priceWithTax: 168480,
      monthsPerCycle: 36,
    }),
    mockedCyclePricing({
      intervalCount: 2,
      price: 100800,
      priceWithTax: 120960,
      monthsPerCycle: 24,
    }),
    mockedCyclePricing({
      intervalCount: 1,
      price: 58800,
      priceWithTax: 70560,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 5600,
      priceWithTax: 6720,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: 'ad042b4a-799c-4fb6-a0ba-33cf8bd83f9e',
  productTypeId: '8b1b47e6-9f58-4e59-b147-cac894bec8da',
  productFamilyId: 'a60e81f8-6daa-4659-8ec5-5f47328a0d4c',
});

const dynamoSunriseProduct1 = {
  ...dynamoProduct1,
  productId: PRODUCT_GUIDS.SUNRISE_V2_LIGHT,
  name: 'Light',
};
const dynamoSunriseProduct2 = {
  ...dynamoProduct2,
  productId: PRODUCT_GUIDS.SUNRISE_V2_CORE,
  name: 'Core',
};
const dynamoSunriseProduct3 = {
  ...dynamoProduct4,
  productId: PRODUCT_GUIDS.SUNRISE_V2_BUSINESS,
  name: 'Business',
};
const dynamoSunriseProduct4 = {
  ...dynamoProduct5,
  productId: PRODUCT_GUIDS.SUNRISE_V2_BUSINESS_ELITE,
  name: 'Business Elite',
};

const dynamoStudioProduct1 = {
  ...dynamoProduct1,
  productId: PRODUCT_GUIDS.WIX_STUDIO_V1_BASIC,
  name: 'Basic',
};
const dynamoStudioProduct2 = {
  ...dynamoProduct2,
  productId: PRODUCT_GUIDS.WIX_STUDIO_V1_STANDARD,
  name: 'Standard',
};
const dynamoStudioProduct3 = {
  ...dynamoProduct3,
  productId: PRODUCT_GUIDS.WIX_STUDIO_V1_PLUS,
  name: 'Plus',
};
const dynamoStudioProduct4 = {
  ...dynamoProduct4,
  productId: PRODUCT_GUIDS.WIX_STUDIO_V1_ELITE,
  name: 'Elite',
};

const dynamoSunriseEnterpriseProduct = aDynamoProduct({
  productId: PRODUCT_GUIDS.SUNRISE_V2_ENTERPRISE,
  name: 'Enterprise',
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 1,
      price: 0,
      priceWithTax: 0,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalCount: 3,
      price: 0,
      priceWithTax: 0,
      monthsPerCycle: 36,
    }),
    mockedCyclePricing({
      intervalCount: 1,
      intervalUnit: IntervalUnit.MONTH,
      price: 0,
      priceWithTax: 0,
      monthsPerCycle: 1,
    }),
    mockedCyclePricing({
      intervalCount: 2,
      price: 0,
      priceWithTax: 0,
      monthsPerCycle: 24,
    }),
  ],
  sbsProductIdPoc: '9832e35a-f7f8-4ced-89f2-c2b3d80516a6',
  productTypeId: '8b1b47e6-9f58-4e59-b147-cac894bec8da',
  productFamilyId: 'a60e81f8-6daa-4659-8ec5-5f47328a0d4c',
});

const dynamoStudioEnterpriseProduct = { ...dynamoSunriseEnterpriseProduct };

export const productsMock: ProductInfo[] = [
  dynamoProduct1,
  dynamoProduct2,
  dynamoProduct3,
  dynamoProduct4,
  dynamoProduct5,
  dynamoProduct6,
  dynamoProduct7,
];

export const productsSunriseMock: ProductInfo[] = [
  dynamoSunriseProduct1,
  dynamoSunriseProduct2,
  dynamoSunriseProduct3,
  dynamoSunriseProduct4,
  dynamoSunriseEnterpriseProduct,
];

export const productsWixStudioMock: ProductInfo[] = [
  dynamoStudioProduct1,
  dynamoStudioProduct2,
  dynamoStudioProduct3,
  dynamoStudioProduct4,
  dynamoStudioEnterpriseProduct,
];

export const productsSunriseMockForUpgradeOrDowngrade: ProductInfo[] = [
  {
    ...dynamoSunriseProduct1,
    purchasableCycles: [],
    downgradePurchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 1 }),
    ],
  },
  {
    ...dynamoSunriseProduct2,
    purchasableCycles: [],
    downgradePurchasableCycles: [],
  },
  {
    ...dynamoSunriseProduct3,
    purchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 2 }),
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 3 }),
    ],
    downgradePurchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 1 }),
    ],
  },
  {
    ...dynamoSunriseProduct4,
    purchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 2 }),
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 3 }),
    ],
    downgradePurchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 1 }),
    ],
  },
  dynamoSunriseEnterpriseProduct,
];

export const productsMockForUpgradeOrDowngrade: ProductInfo[] = [
  {
    ...dynamoProduct1,
    purchasableCycles: [],
    downgradePurchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 1 }),
    ],
  },
  {
    ...dynamoProduct2,
    purchasableCycles: [],
    downgradePurchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 1 }),
    ],
  },
  {
    ...dynamoProduct3,
    purchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 2 }),
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 3 }),
    ],
    downgradePurchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 1 }),
    ],
  },
  {
    ...dynamoProduct4,
    purchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 2 }),
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 3 }),
    ],
    downgradePurchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 1 }),
    ],
  },
  {
    ...dynamoProduct5,
    purchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 1 }),
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 2 }),
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 3 }),
    ],
    downgradePurchasableCycles: [],
  },
  {
    ...dynamoProduct6,
    purchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 1 }),
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 2 }),
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 3 }),
    ],
    downgradePurchasableCycles: [],
  },
  {
    ...dynamoProduct7,
    purchasableCycles: [
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 1 }),
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 2 }),
      aPurchasableCycle({ unit: IntervalUnit.YEAR, count: 3 }),
    ],
    downgradePurchasableCycles: [],
  },
];

export const generateProductsMockOnSale = (
  mockedProducts: ProductInfo[],
): ProductInfo[] =>
  mockedProducts.map((product) => {
    const salePricing = getSalePricingMockByProductId(product?.productId!);
    return salePricing
      ? {
          ...product,
          pricingInfo: {
            ...product.pricingInfo,
            salePricing,
          },
        }
      : product;
  });

export enum DynamoFeatureMockName {
  BooleanSameForAll = 'BooleanSameForAll',
  BooleanFalseForFree = 'BooleanFalseForFree',
  ValueSameForAll = 'ValueSameForAll',
  ValueDifferentForFree = 'ValueDifferentForFree',
}

const dayfulProductAdvanced = aDynamoProduct({
  name: 'Advanced',
  productId: 'bca7c028-2002-4bfc-8993-15b480ed79fa',
  features: [
    aDynamoFeature({
      name: DynamoFeatureMockName.ValueDifferentForFree,
      tooltip: `${DynamoFeatureMockName.ValueDifferentForFree} Tooltip`,
      isBoolean: false,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 1,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.ValueSameForAll,
      tooltip: `${DynamoFeatureMockName.ValueSameForAll} Tooltip`,
      isBoolean: false,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 2,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.BooleanFalseForFree,
      tooltip: `${DynamoFeatureMockName.BooleanFalseForFree} Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 3,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.BooleanSameForAll,
      tooltip: `${DynamoFeatureMockName.BooleanSameForAll} Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupB", "key":"Group B", "iconKey":"group-b-icon", "priority":2}',
      priority: 1,
    }),
    aDynamoFeature({
      name: 'Customer Care',
      tooltip: `Customer care Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupB", "key":"Group B", "iconKey":"group-b-icon", "priority":2}',
      priority: 2,
      falseValue: '24/7 customer care',
      value: 'Priority',
    }),
  ],
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 1,
      price: 298800,
      priceWithTax: 358560,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 5600,
      priceWithTax: 6720,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: 'ad042b4a-799c-4fb6-a0ba-33cf8bd83f9e',
  productTypeId: 'b5824dc4-dfe0-447b-8e00-f6ab5c326ef6',
  productFamilyId: 'a60e81f8-6daa-4659-8ec5-5f47328a0d4c',
});

const dayfulProductStandard = aDynamoProduct({
  name: 'Standard',
  productId: '5235e4ee-1b3f-4373-b012-4e8885ffe5d8',
  features: [
    aDynamoFeature({
      name: DynamoFeatureMockName.ValueDifferentForFree,
      tooltip: `${DynamoFeatureMockName.ValueDifferentForFree} Tooltip`,
      isBoolean: false,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 1,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.ValueSameForAll,
      tooltip: `${DynamoFeatureMockName.ValueSameForAll} Tooltip`,
      isBoolean: false,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 2,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.BooleanFalseForFree,
      tooltip: `${DynamoFeatureMockName.BooleanFalseForFree} Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 3,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.BooleanSameForAll,
      tooltip: `${DynamoFeatureMockName.BooleanSameForAll} Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupB", "key":"Group B", "iconKey":"group-b-icon", "priority":2}',
      priority: 1,
    }),
    aDynamoFeature({
      name: 'Customer Care',
      tooltip: `Customer care Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupB", "key":"Group B", "iconKey":"group-b-icon", "priority":2}',
      priority: 2,
      falseValue: '24/7 customer care',
      value: 'Priority',
    }),
  ],
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 1,
      price: 70800,
      priceWithTax: 84960,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 4700,
      priceWithTax: 5640,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: '81533fb1-25f2-4f6a-91e5-1bf06ca643d7',
  productTypeId: '8b1b47e6-9f58-4e59-b147-cac894bec8da',
  productFamilyId: '07e91af2-2c8e-485d-8a36-98ac2e8d6bab',
});

const dayfulProductBasic = aDynamoProduct({
  name: 'Basic',
  productId: '511400ba-37e9-457e-a305-07926e054790',
  features: [
    aDynamoFeature({
      name: DynamoFeatureMockName.ValueDifferentForFree,
      tooltip: `${DynamoFeatureMockName.ValueDifferentForFree} Tooltip`,
      isBoolean: false,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 1,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.ValueSameForAll,
      tooltip: `${DynamoFeatureMockName.ValueSameForAll} Tooltip`,
      isBoolean: false,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 2,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.BooleanFalseForFree,
      tooltip: `${DynamoFeatureMockName.BooleanFalseForFree} Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 3,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.BooleanSameForAll,
      tooltip: `${DynamoFeatureMockName.BooleanSameForAll} Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupB", "key":"Group B", "iconKey":"group-b-icon", "priority":2}',
      priority: 1,
    }),
    aDynamoFeature({
      name: 'Customer Care',
      tooltip: `Customer care Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupB", "key":"Group B", "iconKey":"group-b-icon", "priority":2}',
      priority: 2,
      falseValue: '24/7 customer care',
      value: 'Priority',
    }),
  ],

  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 1,
      price: 22800,
      priceWithTax: 27360,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 4700,
      priceWithTax: 5640,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: 'ad042b4a-799c-4fb6-a0ba-33cf8bd83f9e',
  productTypeId: 'b5824dc4-dfe0-447b-8e00-f6ab5c326ef6',
  productFamilyId: '217fdefb-918b-46cb-8cfa-c010cbff46f9',
});

const dayfulProductFree = aDynamoProduct({
  name: 'Free',
  productId: 'a1ae2ee6-1c98-4a8a-97cc-285938c8f1b2',
  features: [
    aDynamoFeature({
      name: DynamoFeatureMockName.ValueDifferentForFree,
      tooltip: `${DynamoFeatureMockName.ValueDifferentForFree} Tooltip`,
      isBoolean: false,
      quotaFeatureLimit: 1,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 1,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.ValueSameForAll,
      tooltip: `${DynamoFeatureMockName.ValueSameForAll} Tooltip`,
      isBoolean: false,
      group:
        '{"id":"groupA", "key":"Group A", "iconKey":"group-a-icon", "priority":1}',
      priority: 2,
    }),
    aDynamoFeature({
      name: DynamoFeatureMockName.BooleanSameForAll,
      tooltip: `${DynamoFeatureMockName.BooleanSameForAll} Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupB", "key":"Group B", "iconKey":"group-b-icon", "priority":2}',
      priority: 1,
    }),
    aDynamoFeature({
      name: 'Customer Care',
      tooltip: `Customer care Tooltip`,
      isBoolean: true,
      group:
        '{"id":"groupB", "key":"Group B", "iconKey":"group-b-icon", "priority":2}',
      priority: 2,
      falseValue: '24/7 customer care',
      value: 'Priority',
    }),
  ],
  catalogPricing: [
    mockedCyclePricing({
      intervalCount: 1,
      price: 0,
      priceWithTax: 0,
      monthsPerCycle: 12,
    }),
    mockedCyclePricing({
      intervalUnit: IntervalUnit.MONTH,
      intervalCount: 1,
      price: 0,
      priceWithTax: 0,
      monthsPerCycle: 1,
    }),
  ],
  sbsProductIdPoc: '6e8fbb87-aca3-42bc-b8c7-c040fed78fee',
  productTypeId: 'b5824dc4-dfe0-447b-8e00-f6ab5c326ef6',
  productFamilyId: '217fdefb-918b-46cb-8cfa-c010cbff46f9',
});

export const dayfulBaseProducts = [
  dayfulProductAdvanced,
  dayfulProductStandard,
  dayfulProductBasic,
];

export const dayfulProducts = [...dayfulBaseProducts, dayfulProductFree];
